import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersRegistrationComponent } from './users-registration.component';

const routes: Routes = [
  {
path: '',
component: UsersRegistrationComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRegistrationRoutingModule { }
